import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsAllocationOverviewItem,
  FamsAllocationOverviewListResponse,
  FamsAllocationOverviewOptionsResponse,
  FamsAllocationOverviewQueryParams,
} from './types/allocation-overview';

const request = createAppRequest();

export async function getFamsAllocationOverviewOptions(
  params?: Pick<FamsAllocationOverviewQueryParams, 'snapshotDate'>,
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationOverviewOptionsResponse>('/bff/fams/allocation-overview/options', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsAllocationOverviewList(
  params?: FamsAllocationOverviewQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationOverviewListResponse>('/bff/fams/allocation-overview/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsAllocationOverviewDetail(
  id: string,
  params?: Pick<FamsAllocationOverviewQueryParams, 'snapshotDate'>,
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationOverviewItem>(`/bff/fams/allocation-overview/${id}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
